"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosImageSearchOnlyResponseSchema = exports.APosImageSearchOnlyRequestSchema = exports.APosDescriptionOnlyResponseSchema = exports.APosDescriptionOnlyRequestSchema = exports.APosProductAssistResponseSchema = exports.APosProductAssistRequestSchema = exports.APosProductAssistImageCandidateSchema = void 0;
const zod_1 = require("zod");
const agent_credits_schema_1 = require("./agent-credits.schema");
/**
 * AgenticPOS AI Product Assist — API schemas
 *
 * Wave 1+ endpoints. Declared in Wave 0 so the entire surface
 * is typed in one place and so the credit charge summary type
 * is shared with handlers.
 *
 *   POST /agents/product-assist
 *   POST /agents/description-only
 *   POST /agents/image-search-only
 */
// ---------- Image candidate shared across endpoints ----------
exports.APosProductAssistImageCandidateSchema = zod_1.z.object({
    id: zod_1.z.string(),
    thumbnailUrl: zod_1.z.string().url(),
    fullUrl: zod_1.z.string().url(),
    sourcePageUrl: zod_1.z.string().url(),
    title: zod_1.z.string().nullable().optional(),
    displayLink: zod_1.z.string().nullable().optional(),
    width: zod_1.z.number().int().positive().nullable().optional(),
    height: zod_1.z.number().int().positive().nullable().optional(),
});
// ---------- POST /agents/product-assist ----------
exports.APosProductAssistRequestSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(200),
    category: zod_1.z.string().min(1).max(200),
    brand: zod_1.z.string().max(200).optional(),
    /**
     * Grounding mode (Wave 1.6+):
     *   'product' — marketing-quality hero photos + description (default)
     *   'variant' — SKU-exact photos for one specific variant, no description
     */
    mode: zod_1.z.enum(['product', 'variant']).optional(),
});
exports.APosProductAssistResponseSchema = zod_1.z
    .object({
    images: zod_1.z.array(exports.APosProductAssistImageCandidateSchema),
    description: zod_1.z.string(),
    descriptionConfidence: zod_1.z.number().min(0).max(1).optional(),
    operationId: zod_1.z.string(),
})
    .merge(agent_credits_schema_1.APosAgentCreditChargeSummarySchema);
// ---------- POST /agents/description-only ----------
exports.APosDescriptionOnlyRequestSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(200),
    category: zod_1.z.string().min(1).max(200),
    brand: zod_1.z.string().max(200).optional(),
    context: zod_1.z.string().max(2000).optional(),
});
exports.APosDescriptionOnlyResponseSchema = zod_1.z
    .object({
    description: zod_1.z.string(),
    descriptionConfidence: zod_1.z.number().min(0).max(1).optional(),
})
    .merge(agent_credits_schema_1.APosAgentCreditChargeSummarySchema);
// ---------- POST /agents/image-search-only ----------
exports.APosImageSearchOnlyRequestSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(200),
    category: zod_1.z.string().min(1).max(200),
    brand: zod_1.z.string().max(200).optional(),
});
exports.APosImageSearchOnlyResponseSchema = zod_1.z
    .object({
    images: zod_1.z.array(exports.APosProductAssistImageCandidateSchema),
    operationId: zod_1.z.string(),
})
    .merge(agent_credits_schema_1.APosAgentCreditChargeSummarySchema);
//# sourceMappingURL=product-assist.schema.js.map